'use client';

import { useMemo } from 'react';
import {
  useCreateRegionFilters,
} from '@/creditflowresearch/application/PageFilters/hooks/create';
import type { IRegionFilter } from '@/creditflowresearch/application/PageFilters/hooks/create';
import Region, { RegionType } from '@/creditflowresearch/domain/Region';
import { EM_FILTER_REGION_IDS, EM_BETA_REGION_IDS } from '@/creditflowresearch/application/PageFilters/constants';

const BETA_SUFFIX = ' (Beta)';

export const useEmRegionFilters = (): IRegionFilter[] => {
  const allRegions = useCreateRegionFilters();

  return useMemo(
    () => allRegions
      .filter(({ id }) => EM_FILTER_REGION_IDS.includes(id))
      .map((filter) => {
        const region = Region.from(filter.id);
        const emName = region?.getEmDisplayName()?.toUpperCase();

        if (!emName) {
          return filter;
        }

        // TODO: Once BE provides correct beta field per EM region, replace EM_BETA_REGION_IDS with:
        //  1. Import { useHeaderMenuContext } from '@/creditflowresearch/application/HeaderMenu/HeaderMenuContext'
        //  2. Get regionsList: const { regions: regionsList } = useHeaderMenuContext()
        //  3. Find region data: const regionData = regionsList.find((r) => r.id === filter.id)
        //  4. Use regionData?.beta instead of EM_BETA_REGION_IDS.includes(filter.id)
        return {
          ...filter,
          // TODO: remove when the European market opening period ends; CEEMEA then
          // locks with the other EM regions
          disabled: !region.isOfType(RegionType.EMEA) && filter.disabled,
          abbreviation: EM_BETA_REGION_IDS.includes(filter.id) ? `${ emName }${ BETA_SUFFIX }` : emName,
        };
      }),
    [allRegions],
  );
};
